import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-flat-button',
    templateUrl: './flat-button.component.html',
    styleUrls: ['./flat-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FlatButtonComponent {
    @Input()
    label: string = '';

    @Input()
    color: string = '';

    @Input()
    icon: string = '';

    @Input()
    svgIcon: string = '';

    @Input()
    disabled: boolean = false;

    @Input()
    isLoading: boolean = false;

    @Input()
    showThreeDots: boolean = false;

    @Input()
    participantViewButton: boolean = false;

    @Input()
    isSecondaryButton: boolean = false;

    @Input()
    autofocus: boolean = false;

    @Input()
    counter: number = 0;

    @Input()
    iconRight: boolean = false;

    @Input()
    showArrowDown: boolean = false;

    @Input()
    fullWidth: boolean = false;

    @Input()
    forceTrailingIconOnRight: boolean = false;

    /** When true, fills the flat button with brand green (#A2C617) and light label/icon. Overrides theme palette chosen via `color`. */
    @Input()
    brandGreenButton: boolean = false;

    @Output()
    onClick = new EventEmitter<any>();

    constructor() {}

    onClickButton(event): void {
        this.onClick.emit(event);
    }
}
